import { render, staticRenderFns } from "./WizardStep1.vue?vue&type=template&id=f05d6926"
import script from "./WizardStep1.vue?vue&type=script&lang=js"
export * from "./WizardStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports